// URL query switches, see README "Switches". A switch is on when its key is
// present in the query and off with `name=0`. Only whole keys match, so
// values like `?redirect=disable-swift` don't toggle anything.

// checkQueryParam :: (String, String, Bool) -> Bool
export const checkQueryParam = (search, name, fallback = false) => {
  const params = new URLSearchParams(search);
  if (!params.has(name)) return fallback;
  return params.get(name) !== '0';
};
